import { createMuiTheme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core'

// Styles
export const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 5px',
  },
  dialogTitle: {
    fontSize: 26,
    padding: '0 15px 0 0',
    color: '#696969',
  },
  inputArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 25px',
  },
  subText: {
    fontWeight: 'bold',
  },
  copyBtn: {
    fontSize: 12
  },
  notchedOutline: {
    borderColor: '#6c757d !important',
  },
  appBtn: {
    textTransform: 'none',
    margin: '3rem 1rem 1rem 1rem',
    fontSize: 16
  },
  popText: {
    fontSize: 14,
    padding: '5px 10px 0 10px',
  },
  noteText: {
    fontSize: 12,
    padding: '0 0.5rem 0.5rem 0.5rem',
  }
})

// Material UI Theme
export const theme = createMuiTheme({
  overrides: {
    MuiDialog: {
      paperScrollPaper: {
        border: '2px solid #7ECBD5',
        borderRadius: 15,
      },
    },
    MuiAvatar: {
      root: {
        width: 'initial',
      },
    },
    MuiButton: {
      root: {
        lineHeight: 2.5,
      },
      contained: {
        color: '#fff',
        backgroundColor: '#7ECBD5',
      },
    },
    MuiFormControl: {
      root: {
        marginRight: 10,
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: 14
      }
    },
    PrivateNotchedOutline: {
      root: {
        borderWidth: 2,
      }
    },
    MuiTypography: {
      root: {
        marginBottom: 10
      },
      subtitle2: {
        color: '#6c757d',
      },
      body1: {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif !important",
      }
    },
  }
})